import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { JobsService } from '@tt-chvac/job';
import { WorkPackageSearchService } from '@tt-chvac/work-package';
import { LoaderService, RefreshService } from '@tt-chvac/core';
import { CommonService as CommonServiceService, ApiErrorService, FeatureEnum } from '@tt-chvac/core-sales-web';
import { filter, Subscription } from 'rxjs';
import { AppConstants } from '../../../shared/constants/constants';
import { GlobalSearchService } from './../../../shared/services/global-search.service';
import { HomePageTitlesEnum } from './../models/home-page-title.model';
import { AuthorizeAccessService } from '../../../shared/services/authorize-access.service';
import { SalesOfficeModel, TraneSalesBusinessDataService, UserService } from '@tt-chvac/acquisition-data-service';
import { UserInfoService } from '@tt-chvac/core-sales-web';
import { DisplayModeEnum } from '../../../shared/enums/display-mode-enum';
import { RevenueStreamEnum } from '../../../shared/enums/revenue-stream-enum';
import { IDashboardPreference } from '../../../shared/model/dashboard-preferences';
import { UserService as UserPreferenceService } from '../../../modules/jobs-list-master/services/user.service';
import { isDeployedToProd } from '../../../../environments/environment-helper';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-home-page-list',
    templateUrl: './home-page-list.component.html',
    styleUrls: ['./home-page-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class HomePageListComponent implements OnInit, AfterViewInit, OnDestroy {
  public disable = false;
  public showIcon = false;
  public hasError: boolean;
  public errorText: string;
  public selectedTab = '';
  public drAddressId: number;
  public salesOfficeName: string;
  public currentUrl: string;
  public selectedMenu: any;
  public searchValue: string;
  public productFamily: string;
  public searchStatus: boolean;
  public alreadySearchedValue: any;
  public alreadySearchedTimeframe: string;
  public currentToggleSelected: string;
  public routerEventSubscription: Subscription;
  public activeToggleSubscription: Subscription;
  public subscriptions: Subscription[] = [];
  ShippingHistoryDisplayMode: string;
  alertMessage: string;
  public constSearchTypes = {
    jobsSearchType: 'Jobs',
    productFamilySearchType: 'Product Family',
  };
  searchTypes: string[] = [
    this.constSearchTypes.jobsSearchType,
    this.constSearchTypes.productFamilySearchType];

  public constSearchCategories = {
    all: RevenueStreamEnum.All,
    equipment: RevenueStreamEnum.Equipment,
    contracting: RevenueStreamEnum.Contracting,
  };

  searchCategories: string[] = [
    this.constSearchCategories.all,
    this.constSearchCategories.equipment,
    this.constSearchCategories.contracting];

  selectedSearchCategory: string = this.constSearchCategories.all;

  public constTimeframes = {
    oneWeek: 'in the past week',
    oneMonth: 'in the past month',
    oneYear: 'in the past year',
    threeYears: 'in the past 3 years',
  };

  timeframes: string[] = [
    this.constTimeframes.oneWeek,
    this.constTimeframes.oneMonth,
    this.constTimeframes.oneYear,
    this.constTimeframes.threeYears,
  ];

  public timeLimitErrorText: string;

  selectedSearchType = this.constSearchTypes.jobsSearchType;
  selectedTimeframe = this.constTimeframes.oneWeek;
  @Output() searchEvent = new EventEmitter<any>();

  public tabMenus = [
    { title: HomePageTitlesEnum.Home, status: true, url: 'home' },
    { title: HomePageTitlesEnum.Jobs, status: true, url: 'jobs-list' },
    { title: HomePageTitlesEnum.DelegatedJobs, status: true, url: 'delegated-jobs-list' },
    { title: HomePageTitlesEnum.Projects, status: true, url: 'projects' },
    { title: HomePageTitlesEnum.WorkPackages, status: true, url: 'home-page-list' },
  ];
  public hideTabs = false;
  public isLoadTsmtOfficeSelector = true;
  public showSearch = true;
  public showProductFamilySearch = true;
  public showRefresh = true;
  public lastRefresh: Date;
  public refreshSpinClass = '';
  public userDetails: string;
  public userId: string;
  public employeeType: string;
  public filteredUserRole: string[];
  public isCommissionSplitExcluded = true;
  public onlyShowMyRequests = true;
  public userPreferences: IDashboardPreference;
  public isProdEnvironment = isDeployedToProd();
  public isEnableMultiOffice = environment.enableMultiOffice;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private globalSearchService: GlobalSearchService,
    private translateService: TranslateService,
    private commonService: CommonServiceService,
    private workPackageSearchService: WorkPackageSearchService,
    private apiErrorService: ApiErrorService,
    private appConstants: AppConstants,
    private loaderService: LoaderService,
    private jobsService: JobsService,
    private refreshService: RefreshService,
    private authorizeAccessService: AuthorizeAccessService,
    private userService: UserService,
    private userInfoService: UserInfoService,
    private userPreferenceService: UserPreferenceService,
    private traneSalesBusinessDataService: TraneSalesBusinessDataService) {
    if (environment.enableTableau) {
      this.tabMenus.push(
        { title: HomePageTitlesEnum.Tableau, status: true, url: 'tableau' }
      );
    }
    this.translateService.setDefaultLang(this.appConstants.TRANSLATION_LANGUAGE);
    this.ShippingHistoryDisplayMode = this.appConstants.ShippingHistoryDisplayMode;
    this.hideMenuForReadonlyUser();
    this.routerEventSubscription = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.selectedTab = this.getTitle();
      this.setPageDefaults();
      this.loaderService.hide();
    });
  }

  ngOnInit() {
    this.translateService.use(this.appConstants.TRANSLATION_LANGUAGE);

    if (typeof this.router.url === 'string') {
      this.hideTabs = (this.router.url.includes('exit')) ?
        true : (this.router.url.split('/').length > 4);
    }

    this.subscriptions.push(this.userPreferenceService.getDashboardPreferences().subscribe(prefs => {
      this.userPreferences = prefs ?? { onlyShowMyRequests: true, tiles: [] };
      this.userPreferences.onlyShowMyRequests = true;
      this.userPreferenceService.setDashboardPreferences(this.userPreferences).subscribe(pref => {
        this.refreshService.refreshSubject.next(this.appConstants.ONLY_SHOW_MY_REQUESTS_STATUS);
      });
    }));

    // update title on office selector change
    this.subscriptions.push(this.traneSalesBusinessDataService.getAllSalesOffices().subscribe((selectedOffice: SalesOfficeModel[]) => {
      if (this.drAddressId) {
        this.salesOfficeName = selectedOffice.find(item => item.drAddressId === this.drAddressId).salesOfficeName;
      }
      if (this.selectedTab === HomePageTitlesEnum.Home) {
        this.refreshView(false);
      }
      this.updateTitleAndClearSearch();
    }));

    this.subscriptions.push(this.jobsService.searchClear.subscribe(() => {
      this.clearSearchText();
    }));

    this.alertMessage = `<ol>
    <li>Searches large unitary and applied systems equipment, DOES NOT include light commercial unitary (gen. <25T)</li>
    <li>Serial Number search also returns Sales Order number such as "A1A123", which is expanded to
        "A1-A123" for system to search archival scanned documents</li>
    <li>Partial character search is highly recommended, start with full Serial Number string and then try
        number groupings</li>
    <li class="t-text-error t-text-700">Not all units are in this historical location – record availability for serial numbers pre-1994 depends on product,
     if serial numbers are found, does not guarantee documents are also available and records for serial numbers J96-J98 are generally not available</li>
</ol>`;

    // Getting the user details based on the userId
    this.userId = this.userInfoService.getUserId();
    this.subscriptions.push(this.userService.getUserDetails([this.userId]).subscribe(
      userDetails => {
        this.employeeType = userDetails[0].employeeType;
      }
    ));

    // Filtering the 'CTXDBSELECTOR' role for prod environment and 'CTXDBSELECTORTEST' for non-prod environments
    const user_role = this.isProdEnvironment ? this.appConstants.USER_ROLE : this.appConstants.USER_ROLE_TEST;
    this.filteredUserRole = this.userInfoService.getUserRoles().filter((x) =>
      x.toString().toUpperCase() === user_role);
    if (!this.isEnableMultiOffice) {
      this.tabMenus = this.tabMenus.filter(menu => menu.title !== HomePageTitlesEnum.DelegatedJobs);
    }
  }

  // handles changing the selected search type on the jobs page
  onSearchTypeChange(searchType: string): void {
    if (searchType) {
      this.selectedSearchType = searchType;
      this.selectedTimeframe = this.constTimeframes.oneWeek;
      this.hasError = false;
      this.clearSearchText();
    }
  }

  // handles changing the timeframe when searching via product code on the jobs page
  onTimeframeChange(searchType: string): void {
    if (searchType) {
      this.selectedTimeframe = searchType;
      if (this.selectedTimeframe === this.constTimeframes.threeYears) {
        this.timeLimitErrorText = this.appConstants.SEARCH_JOBS_THREE_YEARS;
      } else {
        this.timeLimitErrorText = this.appConstants.SEARCH_JOBS_ONE_YEAR;
      }
    }
  }

  /**
   * Handles changing the selected search category (All / Equipment / Contracting) on the search bar.
   * @param searchCategory - The newly selected search category.
   * @returns void
   */
  onSearchCategoryChange(searchCategory: string): void {
    if (searchCategory) {
      this.selectedSearchCategory = searchCategory;
      this.hasError = false;
      this.clearSearchText();
    }
  }

  ngAfterViewInit() {
    /* getting current selected toggle information from project screen*/
    this.activeToggleSubscription = this.commonService.activeToggleState.subscribe((activeToggle: string) => {
      if (activeToggle && this.selectedTab === HomePageTitlesEnum.Projects) {
        // Added isLoadTsmtOfficeSelector is false when selected tab is project to display app office selector component
        this.isLoadTsmtOfficeSelector = activeToggle === 'Untransmitted';
        this.currentToggleSelected = activeToggle;
        if (this.alreadySearchedValue !== '' && this.currentToggleSelected) {
          // get records with search filter
          this.globalSearchService.searchList(this.searchValue.trim(), this.selectedTab, this.drAddressId, {
            currentDataSelected: this.currentToggleSelected,
            isCommissionSplitExcluded: this.isCommissionSplitExcluded,
            revenueStreamType: this.selectedSearchCategory,
          });
        }
      } else if (this.selectedTab === (HomePageTitlesEnum.WorkPackages || HomePageTitlesEnum.Jobs)) {
        // Added isLoadTsmtOfficeSelector is true when selected tab is Work Packages to display TSMT office selector component
        this.isLoadTsmtOfficeSelector = true;
        this.currentToggleSelected = this.selectedTab;
      } else {
        this.currentToggleSelected = 'Transmitted';
      }
    });
    this.loaderService.hide();
    this.showRefresh = this.selectedTab === HomePageTitlesEnum.Home;
  }

  ngOnDestroy(): void {
    this.routerEventSubscription?.unsubscribe();
    this.activeToggleSubscription?.unsubscribe();
    while (this.subscriptions.length > 0) {
      const subscription = this.subscriptions.shift();
      subscription.unsubscribe();
    }
  }

  getTitle() {
    const urlArray = this.router.url.split('?')[0].split('/');
    if (!urlArray.includes('work-packages')) {
      this.currentUrl = urlArray[1];
      this.drAddressId = +urlArray.pop();
      this.selectedMenu = this.tabMenus.filter((menu) => this.currentUrl === menu.url);
      // by default projects tab will be Selected but on refresh current tab
      return this.selectedMenu.length > 0 ? this.selectedMenu[0].title :
        (this.tabMenus.length === 1 ? this.tabMenus[0].title : this.tabMenus[1].title);
    } else {
      this.drAddressId = +this.route.snapshot.params['drAddressId'];
      this.selectedMenu = { title: HomePageTitlesEnum.WorkPackages, status: true, url: 'work-packages' };
      return HomePageTitlesEnum.WorkPackages;
    }
  }

  onTabSelect(event: any) {
    if (this.selectedTab !== event.title && this.drAddressId && !this.hideTabs) {
      this.loaderService.show();
      this.apiErrorService.hide();
      this.selectedTab = event.title;
      this.searchValue = '';
      this.productFamily = '';
      this.currentToggleSelected = 'Transmitted';
      this.selectedSearchCategory = this.constSearchCategories.all;
      const item = this.tabMenus.filter((tab: any) => tab.title === event.title)[0];
      const routeToHomePageUrl = `${item.url}/${this.drAddressId}`;
      event.title === HomePageTitlesEnum.WorkPackages ?
        this.router.navigate([routeToHomePageUrl + '/work-packages']) : this.router.navigate([routeToHomePageUrl]);
      this.showSearch = (event.title !== HomePageTitlesEnum.Home && event.title !== HomePageTitlesEnum.Jobs);
      this.showProductFamilySearch = (event.title === HomePageTitlesEnum.Jobs);
      this.showRefresh = event.title === HomePageTitlesEnum.Home;
      this.lastRefresh = new Date();
      if (event.title === HomePageTitlesEnum.Home) {
        this.userPreferences = this.userPreferences ?? { onlyShowMyRequests: true, tiles: [] };
        this.onlyShowMyRequests = true;
        this.userPreferences.onlyShowMyRequests = true;
        this.userPreferenceService.setDashboardPreferences(this.userPreferences).subscribe(pref => {
          this.refreshService.refreshSubject.next(this.appConstants.ONLY_SHOW_MY_REQUESTS_STATUS);
        });
      }
      this.showCheckboxInProjectsTab();
    }
  }

  onShowMyRequestsChange(value: boolean) {
    this.userPreferences.onlyShowMyRequests = value;
    this.userPreferenceService.setDashboardPreferences(this.userPreferences).subscribe(pref => {
      this.refreshService.refreshSubject.next(this.appConstants.ONLY_SHOW_MY_REQUESTS_STATUS);
    });
  }

  // set default properties on page load like title , isLoadTsmtOfficeSelector and currentToggleSelected
  setPageDefaults(): void {
    this.hasError = false;
    this.alreadySearchedValue = '';
    this.alreadySearchedTimeframe = '';
    this.isLoadTsmtOfficeSelector = true;
    this.titleService.setTitle(this.selectedTab + (this.salesOfficeName ? '-' + this.salesOfficeName : ''));
    this.currentToggleSelected = this.currentToggleSelected ?? this.selectedTab;
    if (this.selectedTab === HomePageTitlesEnum.Projects) {
      this.currentToggleSelected = this.currentToggleSelected ?? 'Transmitted';
      this.isLoadTsmtOfficeSelector = this.currentToggleSelected === 'Untransmitted';
    }
    this.showSearch = (this.selectedTab !== HomePageTitlesEnum.Home && this.selectedTab !== HomePageTitlesEnum.Jobs);
    this.showProductFamilySearch = (this.selectedTab === HomePageTitlesEnum.Jobs);
    this.clearSearchText();
    this.isCommissionSplitExcluded = true;
  }

  onKey(data: any) {
    if (this.selectedSearchType === this.constSearchTypes.jobsSearchType) {
      this.searchValue = data.target.value;
      if (this.searchValue !== '') {
        this.hasError = false;
        this.showIcon = true;
      } else {
        this.showIcon = false;
        this.clearSearchText();
      }
    } else if (this.selectedSearchType === this.constSearchTypes.productFamilySearchType) {
      this.productFamily = data.target.value;
      if (this.productFamily !== '') {
        this.hasError = false;
        this.showIcon = true;
      } else {
        this.showIcon = false;
        this.clearSearchText();
      }
    }
  }

  public clearSearchText() {
    this.showIcon = false;
    this.searchValue = '';
    this.productFamily = '';
    // get records with no search filter
    if (this.alreadySearchedValue) {
      // Added condition to call work package search service to load the grid data
      if (this.selectedTab === HomePageTitlesEnum.WorkPackages) {
        this.workPackageSearchService.searchList(this.drAddressId, this.searchValue, this.selectedTab);
      } else if (this.selectedTab === HomePageTitlesEnum.Projects) {
        this.globalSearchService.searchValue.next('');
      } else {
        this.globalSearchService.searchList(this.searchValue, this.selectedTab, this.drAddressId);
      }
      this.alreadySearchedValue = null;
      this.alreadySearchedTimeframe = null;
    }
  }

  /**
   * Method that takes in the user input from the textbox in the form of searchText and productFamilyText
   * and sends them off to be searched for using the searchList() method
   */
  public searchJobList(searchText: string, productFamilyText: string): void {
    // If the currently selected tab is Jobs, use the searchText input string, and send it off to be searched for
    if (this.selectedSearchType === this.constSearchTypes.jobsSearchType) {
      if (this.searchValue !== '') {
        if (this.alreadySearchedValue !== searchText) {
          if (this.selectedTab === HomePageTitlesEnum.WorkPackages) {
            this.workPackageSearchService.searchList(this.drAddressId, this.searchValue.trim(), this.selectedTab);
          } else {
            this.globalSearchService.searchList(this.searchValue.trim(), this.selectedTab, this.drAddressId, {
              currentDataSelected: this.currentToggleSelected,
              isCommissionSplitExcluded: this.isCommissionSplitExcluded,
            });
          }
          this.alreadySearchedValue = searchText;
          localStorage.setItem('setSearchText', searchText);
        }
      } else {
        this.hasError = true;
        this.errorText = 'Enter a Key Word';
      }
      // If the currently selected tab is Product Code, use the productFamilyText string,
      // set the date time limit appropriately, and send them off to be searched for
    } else if (productFamilyText !== undefined && this.selectedSearchType === this.constSearchTypes.productFamilySearchType) {
      if (this.productFamily !== '') {
        if (this.alreadySearchedValue !== productFamilyText || this.alreadySearchedTimeframe !== this.selectedTimeframe) {

          const searchDateLimit = new Date();
          if (this.selectedTimeframe === this.constTimeframes.oneWeek) {
            searchDateLimit.setDate(searchDateLimit.getDate() - 7);
          } else if (this.selectedTimeframe === this.constTimeframes.oneMonth) {
            searchDateLimit.setMonth(searchDateLimit.getMonth() - 1);
          } else if (this.selectedTimeframe === this.constTimeframes.oneYear) {
            searchDateLimit.setFullYear(searchDateLimit.getFullYear() - 1);
          } else if (this.selectedTimeframe === this.constTimeframes.threeYears) {
            searchDateLimit.setFullYear(searchDateLimit.getFullYear() - 3);
          }

          this.globalSearchService.searchList(this.productFamily.trim(), this.selectedTab, this.drAddressId, {
            currentDataSelected: this.currentToggleSelected,
            isCommissionSplitExcluded: this.isCommissionSplitExcluded,
            isProductFamilySelected: true,
            timeframeConstraint: searchDateLimit,
          });
          this.alreadySearchedValue = this.productFamily;
          this.alreadySearchedTimeframe = this.selectedTimeframe;
          localStorage.setItem('productFamilyText', productFamilyText);
        }
      }
    }
  }

  /**
   * Triggers a global search for the given search text, passing the selected search category.
   * @param searchText - The trimmed search text to search for.
   */
  public searchRecords(searchText: string) {
    if (this.searchValue !== '') {
      if (this.alreadySearchedValue !== searchText) {
        // get records with search filter
        // Added condition for calling work package search service to load the grid data
        if (this.selectedTab === HomePageTitlesEnum.WorkPackages) {
          this.workPackageSearchService.searchList(this.drAddressId, this.searchValue.trim(), this.selectedTab);
        } else {
          this.globalSearchService.searchList(this.searchValue.trim(), this.selectedTab, this.drAddressId, {
            currentDataSelected: this.currentToggleSelected,
            isCommissionSplitExcluded: this.isCommissionSplitExcluded,
            revenueStreamType: this.selectedSearchCategory,
          });
        }
        this.alreadySearchedValue = searchText;
        localStorage.setItem('setSearchText', searchText);
      }
    } else {
      this.hasError = true;
      this.errorText = 'Enter a Key Word';
    }
  }

  public refreshView(notifyRefreshService: boolean = true): void {
    // Show the loader as a visual that we are refreshing
    this.loaderService.show();

    // Changing office does a redirect, which automagically refreshes the view, so dont notify refresh
    // service to do it again if "notify" is false
    if (notifyRefreshService) {
      this.refreshService.refreshSubject.next('');
    }

    // Set up a fake refresh here...  Just showin some spin so the user knows it's refreshing, separate concurrent
    // API calls may complete before/after the timeout below completes.
    this.refreshSpinClass = 'fa-spin';
    setTimeout(() => {
      this.loaderService.hide();
      this.lastRefresh = new Date();
      this.refreshSpinClass = '';
    }, 1000);
  }

  /**
   * Update title and clear search text
   * @param val as IOfficeSelector
   */
  private updateTitleAndClearSearch(): void {
    const title = this.getTitle();
    if (this.selectedMenu.length > 0) {
      this.selectedTab = title;
    }
    this.titleService.setTitle(this.selectedTab + '-' + this.salesOfficeName);
    // clear search value
    this.clearSearchText();
  }

  /**
   * Hide menu for readonly user based on accessType
   * @param [accessType] as FeatureEnum
   */
  hideMenuForReadonlyUser(accessType: FeatureEnum = FeatureEnum.CreditProject): void {
    if (this.authorizeAccessService.isReadOnlyUser(accessType)) {
      this.tabMenus = [];
      this.tabMenus = [{ title: HomePageTitlesEnum.Projects, status: true, url: 'projects' }];
    }
  }

  /**
   * Method to determine whether to show info icon with tooltip near search box in project landing page
   * @returns true/false
   */
  public showInfoIconInProjectsTab(): boolean {
    return this.selectedTab === HomePageTitlesEnum.Projects && this.showIcon;
  }

  /**
   * Method to show checkbox in project landing page when user is in transmitted tab
   * The user should be an 'SO' user and should not have 'CTXDBSELECTOR' or 'CTXDBSELECTORTEST' roles
   * @returns true/false
   */
  public showCheckboxInProjectsTab(): boolean {
    return (this.employeeType === this.appConstants.SALES_ORDER_USER && this.filteredUserRole.length === 0 &&
      this.selectedTab === HomePageTitlesEnum.Projects &&
      (this.currentToggleSelected === DisplayModeEnum.Transmitted || this.currentToggleSelected === HomePageTitlesEnum.Projects));
  }

  /**
   * Change the isCommissionSplitExcluded boolean property based on value change
   * @param value - updated check state
   * @returns void
   */
  checkBoxValueChange(value: boolean): void {
    this.isCommissionSplitExcluded = !value;
  }
}
